import pFileReader from 'promise-file-reader';
import { useQuery, UseQueryOptions } from 'react-query';

import { getFileBlobFromURL } from '@app/store/transport-layer/files';

function useDownloadImage<T = string | null>(
  { url }: { url: string | null },
  options?: UseQueryOptions<string | null, Error, T>
) {
  return useQuery<string | null, Error, T>(
    ['requesterImageInputFile', url],
    async () => {
      if (url) {
        const blob = await getFileBlobFromURL(url);
        const imageSrc = await pFileReader.readAsDataURL(blob);
        return imageSrc;
      }
      return null;
    },
    options
  );
}

export default useDownloadImage;
